import React from 'react'

interface TableProps {
  value: {
    rows: {
      cells: string[]
      isHeader?: boolean
    }[]
  }
}

/**
 * Custom component for rendering tables in rich text content
 */
const RichTextTable: React.FC<TableProps> = ({ value }) => {
  const { rows } = value
  const hasHeader = rows.length > 0 && rows[0].isHeader

  return (
    <div className="my-8 overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
        {hasHeader && (
          <thead className="bg-gray-50 dark:bg-gray-800">
            <tr>
              {rows[0].cells.map((cell, i) => (
                <th
                  key={i}
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider"
                >
                  {cell}
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-800">
          {rows.slice(hasHeader ? 1 : 0).map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className={
                rowIndex % 2 === 0 ? 'bg-white dark:bg-gray-900' : 'bg-gray-50 dark:bg-gray-800'
              }
            >
              {row.cells.map((cell, cellIndex) => (
                <td
                  key={cellIndex}
                  className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400"
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default RichTextTable
